import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import {
    Button,
    Col,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    CloseButton,
} from "reactstrap"

import Lightbox from "react-image-lightbox"
import moment from "moment"
import { useDispatch, useSelector } from "react-redux"
import { onExcludeScreen, screenVerified, filteredScreenImages } from "store/actions"
import { isEmpty } from "lodash"
import EmptyScreenLayout from "components/Common/EmptyScreenLayout"
import VerifyScreensLayout from "./VerifyScreensLayout"
import CustomCheckboxWithLabel from "components/Common/CustomCheckboxWithLabel"

const VerifyScreenModalCopy = props => {
    const { isOpen, toggle, onHandleverified, activeScreenFilter, screens, expandRowDetails, TogglePrevData, ToggleNextData, currentIndex, expandRowItem } = props
    const [isGallery, setisGallery] = useState(false)
    const [photoIndex, setphotoIndex] = useState(null)
    const [groupimage, setGroupImage] = useState(false)
    const [isSelectAllImage, setIsSelectAllImage] = useState(false)
    const [datalist, setDatalist] = useState([])
    const dispatch = useDispatch();

    const { screensexclude, isMobile, filteredScreensList } = useSelector(state => ({
        screensexclude: state.timesheet.excludescreenSuccessList,
        isMobile: state?.teams?.isMobile,
        filteredScreensList: state.timesheet?.filteredScreenImages,
    }))

    const verifiedDate = (e, type) => {
        onHandleverified(type)
        handleImageSelect(type);
    }
    const mergeData = (filteredScreensList || [])?.map((el, idx) => ({
        applicationName: el.applicationName == null ? "null" : el.applicationName,
        imagePath: el.imagePath,
        capturetime: el.capturetime,
        key: idx,
        id: el.id,
        exclude: el.exclude,
    }))

    // group by images concept
    const groupedData = {}
    mergeData.forEach(item => {
        if (!groupedData[item.applicationName]) {
            groupedData[item.applicationName] = []
        }
        groupedData[item.applicationName].push(item)
    })
    const reducedGroupArr = Object.keys(groupedData).reduce((acc, key) => {
        return acc.concat(groupedData[key]);
    }, []);

    const images = (groupimage ? (reducedGroupArr || []) : (filteredScreensList || []))?.map(screens => screens?.imagePath)
    const photoIds = (groupimage ? (reducedGroupArr || []) : (filteredScreensList || []))?.map(screens => screens?.id)
    const handleImageSelect = (activeScreen) => {
        const data =  screens 
        const filteredDataList = (activeScreen || activeScreenFilter) === "VERIFIED" ? (data || []).filter(el => el.verified) : (data || []).filter(el => !el.verified)
        const updateList = filteredDataList?.map(el => {
            const appname = el?.applicationName == null ? 'null' : el?.applicationName
            // const excludeGrp = !isEmpty(datalist) ? datalist?.find(el => el?.applicationName === appname)?.exclude : el?.exclude
            return {
                ...el,
                applicationName: appname,
                exclude: el.exclude
            }
        })
        const isExcludedAllImg = !isEmpty(updateList) ? (updateList)?.every(el => el?.exclude) : isSelectAllImage
        dispatch(filteredScreenImages(photoIndex ? filteredDataList : updateList))

        const updatedExcludedImgs = !isEmpty(filteredScreensList) ? (filteredScreensList)?.every(el => el?.exclude) : isExcludedAllImg
        setIsSelectAllImage(updatedExcludedImgs)
    }
    useEffect(() => {
        handleImageSelect();
    }, [screens,activeScreenFilter])   
    useEffect(() => {
        if (screensexclude?.message === "Exclude ScreenLog  Successfully") {
            const screenVerifyparams = {
                accountid: props?.type === 'verifyscreens' ? expandRowDetails[currentIndex]?.accountId : expandRowItem?.accountid,
                includeBase64: "false",
                filterEmptyResponses: "false",
                startDateTime: moment(props?.type === 'verifyscreens' ? expandRowDetails[currentIndex]?.startTime : expandRowItem?.startDateTime).format("YYYY-MM-DD"), //fromDate,
                endDateTime: moment(props?.type === 'verifyscreens' ? expandRowDetails[currentIndex]?.startTime : expandRowItem?.endDateTime).format("YYYY-MM-DD"), //toDate
            }
            dispatch(screenVerified(screenVerifyparams))
        }
    }, [screensexclude])

    // ** updating selectedImageIds list by Select/Unselect All option ** //
    useEffect(() => {
        let filteredDataList = filteredScreensList?.map(el => {
            const appname = el?.applicationName == null ? 'null' : el?.applicationName
            return {
                ...el,
                applicationName: appname,
                exclude: (isSelectAllImage || el?.exclude),
            }
        })
        if (activeScreenFilter === "VERIFIED") {
            filteredDataList = filteredDataList?.filter(data => data.verified === true)
          } else {
            filteredDataList = filteredDataList?.filter(data => data.verified === false)
          }
        dispatch(filteredScreenImages(filteredDataList))
    }, [isSelectAllImage, groupimage])

    // ** assigning shortcut key for checkbox selection ** //
    useEffect(() => {
        const handleKeyDown = e => {
            if (e.keyCode === 32 && photoIndex !== null) {
                HideScreenFunction(photoIndex)
            }
        }
        window.addEventListener("keydown", handleKeyDown, true)
        return () => {
            window.removeEventListener("keydown", handleKeyDown, true)
        }
    }, [photoIndex, filteredScreensList])

    // checkbox toogle concept
    const toggleImageBox = () => {
        setGroupImage(!groupimage)
    }

    const handleCheckboxChange = id => {
        const filteredDataList = filteredScreensList?.map(el => {
            return {
                ...el,
                exclude: el?.id === id ? !el?.exclude : el?.exclude
            }
        })
        const isExcluded = filteredDataList?.every(el => el?.exclude)
        setIsSelectAllImage(isExcluded)
        dispatch(filteredScreenImages(filteredDataList))
    }

    // Api call exclude screen
    const verifyScreeyExclude = () => {
        const filteredDataList = filteredScreensList?.map(el => {
            return {
                id: el.id,
                exclude: el?.exclude,
            }
        })
        const screenexcludes = {
            excludeScreenList: filteredDataList,
        }
        dispatch(onExcludeScreen(screenexcludes))

        const isExcluded = filteredDataList?.every(el => el?.exclude)
        setIsSelectAllImage(isExcluded)
        dispatch(filteredScreenImages(filteredDataList))
    }

    const HideScreenFunction = (index) => {
        const updatedHidedDataList = filteredScreensList?.map(el => {
            const updateExclude = el?.id === photoIds[index] ? !el?.exclude : el?.exclude
            return {
                ...el,
                exclude: updateExclude,
            }
        })
        dispatch(filteredScreenImages(updatedHidedDataList))
        props?.setscreenResponse(updatedHidedDataList)
        setTimeout(() => {
            const imageIndex = (index === images?.length - 1) ? index : (index + 1) % images.length
            setphotoIndex(imageIndex);
        }, 1000)
    }


    const handleClose = () => {
        setisGallery(false)
    }

    const handleSelectAllImage = () => {
        setIsSelectAllImage(!isSelectAllImage)

        let filteredDataList = filteredScreensList?.map(el => {
            const appname = el?.applicationName == null ? 'null' : el?.applicationName
            return {
                ...el,
                applicationName: appname,
                exclude: !isSelectAllImage,
            }
        })
        dispatch(filteredScreenImages(filteredDataList))

    }

    const handleSelectGroupedCheckbox = (appName, key) => {
        const excludeGrp = groupedData[appName]?.every(el => el?.exclude === true)
        const screenexcludeArr = filteredScreensList?.map(el => {
            return {
                ...el,
                exclude: el?.applicationName === appName ? !excludeGrp : el?.exclude
            }
        })
        setDatalist(screenexcludeArr)
        const findExclude = !isEmpty(screenexcludeArr) ? screenexcludeArr?.every(ele => ele?.exclude === true) : false
        setIsSelectAllImage(findExclude)
        dispatch(filteredScreenImages(screenexcludeArr))
    }

    const ToggleCloseAction = () => {
        toggle()
        setIsSelectAllImage(false)
        setGroupImage(false)
    }

    const ToggleHideAction = (id, type) => {
        const imageIndex = groupimage ? reducedGroupArr?.findIndex(el => el?.id === id) : filteredScreensList?.findIndex(el => el?.id === id)
        if (type === "image") {
            setisGallery(true)
            setphotoIndex(imageIndex)
        } else {
            handleCheckboxChange(id)
        }
    }

    const ImgeCaption = photoIndex => {
        const updateExclude = filteredScreensList?.find(el => el?.id === photoIds[photoIndex])
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: "100%",
                }}
            >
                {!isMobile && (
                    <div className="d-flex justify-content-flex-end align-self-end">
                        <CloseButton onClick={handleClose} />
                    </div>
                )}
                <div>
                    <div className="d-flex flex-row pt-4 justify-content-between">
                        <Button className="btn btn-primary mb-2  bg-primary">
                            {" "}
                            Team Discussion
                        </Button>
                        <Button className="btn btn-primary mb-2   bg-primary">
                            {" "}
                            Internal Charts{" "}
                        </Button>
                    </div>
                    <Button className="btn btn-primary mb-2  px-5  bg-primary ">
                        Another Project Discussion
                    </Button>
                    <Input className="mb-2 p-3 " multiple></Input>
                 
                    <Input
                        type="checkbox"
                        checked={updateExclude?.exclude}
                        className="form-check-Input me-2 cursor-pointer"
                        id={`Hide${photoIndex}`}
                        onClick={() => {
                            HideScreenFunction(photoIndex)
                        }}
                    />
                    <Label
                        className="form-label primary me-2 cursor-pointer "
                        htmlFor={`Hide${photoIndex}`}
                    >
                        Hide Screen
                    </Label>
                        
                </div>
            </div>
        )
    }
    return (
        <Modal
            isOpen={isOpen}
            role="dialog"
            autoFocus={true}
            centered={true}
            className="exampleModal"
            tabIndex="-1"
            toggle={ToggleCloseAction}
            size="xl"
            backdrop="static"
            keyboard={false}
        >
            <div className="modal-content verify-screenUI">
                <ModalHeader toggle={ToggleCloseAction}>
                    <h4>Verify Screens</h4>
                    <div className="d-flex selectGroupMobile" style={{ justifyContent: "space-between", display: 'flex', width: '100%' }}>
                        <div className="pt-2">
                        <div className="form-check form-check-inline">
                            <Input
                                type="radio"
                                id="customRadioInline2"
                                name="verified"
                                className="form-check-input pb-2"
                                onChange={e => verifiedDate(e, "UNVERIFIED")}
                                defaultChecked={activeScreenFilter == "UNVERIFIED"}
                            />
                            <Label
                                className="form-check-label pb-2"
                                htmlFor="customRadioInline2"
                            >
                                UnVerified
                            </Label>
                        </div>
                        <div className="form-check form-check-inline">
                            <Input
                                type="radio"
                                id="customRadioInline1"
                                name="verified"
                                className="form-check-input"
                                onChange={e => verifiedDate(e, "VERIFIED")}
                                defaultChecked={activeScreenFilter == "VERIFIED"}
                            />
                            <Label
                                className="form-check-label"
                                htmlFor="customRadioInline1"
                            >
                                Verified
                            </Label>
                        </div>
                        </div>
                        {expandRowDetails &&
                            <div className="client-project-name pt-2" style={{ display: 'flex', alignItems: 'center' }}>
                                {expandRowDetails?.length > 1 && <button className="pre-icon" style={{ paddingLeft: 0, marginLeft: '-4px' }} onClick={TogglePrevData} disabled={currentIndex === 0}>
                                    <i className="bx bx-chevron-left" style={{ fontSize: '25px', color: currentIndex === 0 ? "#d4d4d4" : 'orange' }}></i>
                                </button>}
                                <span className="clientProjectName" style={{ lineHeight: 2, fontSize: 18, paddingLeft: '3px' }}>{expandRowDetails[currentIndex]?.clientName} - {expandRowDetails[currentIndex]?.projectName}</span>
                                {expandRowDetails?.length > 1 && <button className="pre-icon" onClick={ToggleNextData} disabled={currentIndex === expandRowDetails?.length - 1}>
                                    <i className="bx bx-chevron-right" style={{ fontSize: '25px', color: (currentIndex === expandRowDetails?.length - 1) ? "#d4d4d4" : 'orange' }}></i>
                                </button>}
                            </div>}
                    </div>
                    {filteredScreensList?.length > 0 && (
                        <div className="d-flex selectGroupMobile" style={{ justifyContent: "space-between", display: 'flex', width: '100%' }}>
                            <div className="pb-2">
                                <CustomCheckboxWithLabel
                                    value={groupimage}
                                    id={"capturescreen"}
                                    onClick={toggleImageBox}
                                    label={"Group Screens by Application"}
                                />
                            </div>
                            <div className="selectAllMobile pt-2">
                                <CustomCheckboxWithLabel
                                    value={isSelectAllImage}
                                    id={"Hide_1"}
                                    onClick={() => handleSelectAllImage()}
                                    label={isSelectAllImage ? "Unselect All" : "  Select All"}
                                    labelStyle={{ width: "100px" }}
                                />
                            </div>
                        </div>
                    )}
                </ModalHeader>
                <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }} className="selectAllBody">
                    <Row>
                        {isGallery ? (
                            <div>
                                <Lightbox
                                    mainSrc={images[photoIndex]}
                                    nextSrc={(photoIndex + 1) % images.length}
                                    prevSrc={photoIndex > 0}
                                    enableZoom={true}
                                    onCloseRequest={() => {
                                        setisGallery(false)
                                    }}
                                    onMovePrevRequest={() => {
                                        setphotoIndex(
                                            (photoIndex + images.length - 1) % images.length
                                        )
                                    }}
                                    onMoveNextRequest={() => {
                                        setphotoIndex((photoIndex + 1) % images.length)
                                    }}
                                    imageCaption={ImgeCaption(photoIndex)}
                                    wrapperClassName={isMobile ? "showScreenResponsive" : "verify-screen-action"}
                                />
                            </div>
                        ) : null}
                        {groupimage == false && (
                            <>
                                {!isEmpty(filteredScreensList) ? (
                                    <VerifyScreensLayout
                                        data={filteredScreensList}
                                        onClick={ToggleHideAction}
                                        // selectedImageIds={selectedImageIds}
                                        groupimage={groupimage}
                                    />
                                ) : (
                                    <EmptyScreenLayout />
                                )}
                            </>
                        )}
                        {groupimage == true && (
                            <>
                                {!isEmpty(groupedData) ? (
                                    Object.keys(groupedData).map((name, index) => (
                                        <React.Fragment key={name}>
                                            {index > 0 && <hr></hr>}
                                            <Row>
                                                <Col />
                                                <Col sm={4}>
                                                    <div
                                                        className="text-center image-title"
                                                        style={{ color: "orange", fontSize: "1rem", width: isMobile && '200px' }}
                                                    >
                                                        {name}
                                                    </div>
                                                </Col>
                                                <Col sm={4} className="image-selectAll">
                                                    <CustomCheckboxWithLabel
                                                        value={groupedData[name]?.every(el => el?.exclude === true)}
                                                        id={`Hide${index}`}
                                                        onClick={() =>
                                                            handleSelectGroupedCheckbox(name, index)
                                                        }
                                                        label={groupedData[name]?.every(el => el?.exclude === true) ? "Unselect All" : "  Select All"}
                                                        customstyle={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            alignSelf: "center",
                                                            right: 0,
                                                            color: "#40454C",
                                                            fontSize: "1rem",
                                                            fontWeight: "normal",
                                                            // letterSpacing: 0.5,
                                                            left: isMobile ? 28 : 36,
                                                        }}
                                                        labelStyle={{
                                                            width: "100px",
                                                            marginLeft: 8,
                                                            alignItems: "center",
                                                        }}
                                                    />
                                                </Col>
                                            </Row>

                                            <VerifyScreensLayout
                                                data={groupedData[name]}
                                                onClick={ToggleHideAction}
                                                // selectedImageIds={selectedImageIds}
                                                groupimage={groupimage}
                                            />
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <EmptyScreenLayout />
                                )}
                            </>
                        )}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex" style={{ justifyContent: "space-between", display: 'flex', width: '100%', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', width: isMobile ? '85%' : 'fit-content'}}>
                            <span style={{ fontSize: "11px", color: "orange" }}>* Excluding multiple screens will shift the hours to evaluation and subject to scrutiny.</span>
                        </div>
                        <div style={{ marginLeft: '10px' }}>
                            {filteredScreensList?.length > 0 && (
                                <Button type="button" color="primary" style={{ marginBottom: isMobile ? '3px' : '0px', marginRight: isMobile ? '0px' : '10px', width: isMobile ? '100%' : 'auto' }} onClick={verifyScreeyExclude}>
                                    Verify Screen
                                </Button>
                            )}
                            <Button type="button" color="secondary" onClick={ToggleCloseAction} style={{ width: isMobile ? '100%' : 'auto' }}>
                                Close
                            </Button>
                        </div>
                    </div>
                </ModalFooter>
            </div>
        </Modal>
    )
}

VerifyScreenModalCopy.propTypes = {
    toggle: PropTypes.func,
    isOpen: PropTypes.bool,
}

export default VerifyScreenModalCopy
